<div class="flex flex-row gap-medpace *:flex-1">
    <medpace-datepicker
        [formCtrl]="formGrp().controls.transactionDate"
        [appearance]="'outline'"
        id="travelTransactionDate"
        [label]="'Transaction Date'"
    ></medpace-datepicker>
    <mds-dropdown
        floatLabel="always"
        [closeOnPageScroll]="false"
        appearance="outline"
        label="Merchant"
        placeholder="Select merchant"
        id="travelMerchantDropdown"
        data-cy="travelMerchantDropdown"
        [options]="travelMerchantValues$ | async"
        [formCtrl]="formGrp().controls.merchant"
    ></mds-dropdown>
</div>
